<script>
  import {styleVars} from '/helper'
  import { datesToString } from '/components/Atoms/EventDate'
  import CardExhibition from '/components/Widgets/CardExhibition.svelte'

  export let event
  export let large = false

  const dates = event?.eventDates?.[0]

  const date = event.dateDisplay || datesToString(dates?.startDateAndTime, dates?.endDateAndTime)
  const title = event.teaser
  const image = event?.backgroundImage?.[0]?.url
  const subtitle = event.title
  const link = { slug: event.slug, section: event.typeHandle+"s"} // pluralize typeHandle to get section


</script>

<CardExhibition
  {date}
  {title}
  {image}
  {subtitle}
  {link}
  {large}
/>

<style lang="scss">

</style>